<template>
  <div class="assign-coupons">
    <volunteers-selector ref="volunteersSelector" @onSubmit="onOpenCouponPopup" btn-label="إسناد كوبون" is-selected-ids full-entity
      hide-group-names-filter hide-class-filter hide-gender-filter hide-collage-filter/>

    <tm-popup :submit="onAssignCouponPopupSubmit" title="إسناد كوبون" ref="couponPopup">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-2">
          <tm-select class="w-full" :options="coupons" label="name" validation-rules="required" name="الكوبون"
            :reduce="name => name.id" v-model="coupon.couponId" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import VolunteersSelector from "@/app/volunteer/components/VolunteersSelector.vue";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmSelect from "@/app/shared/shared-components/TmSelect";
import { RepositoryFactory as LoyaltyRepositoryFactory } from '@/app/loyalty-system/loyalty-repositories/loyaltyRepositoryFactory';
import { RepositoryFactory } from '@/app/loyalty-system/loyalty-repositories/loyaltyRepositoryFactory';

const clientsRepo = RepositoryFactory.get('clientsRepository');
const couponsRepo = LoyaltyRepositoryFactory.get('couponsRepository');

export default {
  name: "AssignCoupons",
  components: {
    TmPopup,
    VolunteersSelector,
    TmSelect
  },
  data() {
    return {
      coupons: [],
      coupon: {
        couponId: null,
        clients: []
      },
    };
  },
  methods: {
    onOpenCouponPopup(payload) {
      this.resetCouponForm();
      this.$refs.couponPopup.open();
      this.coupon.clients = payload.selectedVolunteer.map(volunteer => {
        return {
          clientId: volunteer.id,
          yasserClientId: volunteer.uniqueIdentifier,
          name: volunteer.name
        };
      });
    },
    resetCouponForm() {
      Object.assign(this.coupon, {
        couponId: null,
        clients: []
      });
    },
    async onAssignCouponPopupSubmit() {
      try {
        await clientsRepo.assignCoupons(this.coupon);
        this.$refs.volunteersSelector.unselectAllRows();
        this.$refs.couponPopup.close();
        this.resetCouponForm();
      } catch (err) {
        this.$refs.couponPopup.endLoading();
      }
    },
    async getAllCoupons() {
      const data = await couponsRepo.fetchCoupons();
      this.coupons = data.data;
    },
  },
  mounted() {
    this.getAllCoupons();
  }
};
</script>
